
import { Vue, Component, Prop } from "vue-property-decorator";
import ItemChipsWithMore from "@/components/common/ItemChipsWithMore.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import UIButton from "@/components/button/ui-button.vue";
import FormTextarea from "../form/FormTextarea.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import PaginationConfig from "@/entities/PaginationConfig";
import CardPagination from "@/components/card/PaginationNew.vue";
import paginationConfig from "@/data/paginationConfig";
import UiButton from "@/components/button/ui-button.vue";
import SuggestedResourceTable from "@/components/documents/suggestedResourceTableV2.vue";

@Component({
  components: {
    ModalFullScreen,
    UIButton,
    SuggestedResourceTable,
    FormTextarea,
    CrossIcon,
    UiButton,
    CrossIconHover,
    ItemChipsWithMore,
    CardPagination,
    paginationConfig,
  },
})
export default class SuggestedResourcesModal extends Vue {
  @Prop({ type: Array, required: true }) readonly skillIds!: string[];
  @Prop({ type: Array, required: true }) suitableContractors: string[];
  @Prop({ type: String, default: undefined }) readonly visitId?: string;

  processing: boolean = false;
  isHovered: boolean = false;
  totalCount: number = 0;
  paginationConfig: PaginationConfig = { ...paginationConfig };

  mounted() {
    this.totalCount = this.suitableContractors.length;
    this.paginationConfig.total = this.suitableContractors.length;
    this.paginationConfig.loadedCount = this.suitableContractors.length;
  }

  get title() {
    return `Suggested Resources`;
  }

  get defaultInitialsClasses(): string {
    return "inline-flex h-6 w-6 rounded-full items-center justify-center";
  }
  get bgStyle(): object {
    return {
      background: "#1c64f2",
    };
  }
  activityUpdated(): void {
     this.$emit("activityUpdated");
  }
  get avatarStyleClasses(): Record<string, boolean> {
    return {
      ["border border-primary h-6 w-6"]: true,
    };
  }
  get defaultImageClasses(): string {
    return "inline-block rounded-full object-cover object-center";
  }

  onModalClose(): void {
    this.$emit("close");
  }
  handleCancel(): void {
    this.$emit("close");
  }
}
